import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IndentedListCard } from 'js/components/design-system';
import { listCardPropsForLawyer } from './functions';

const SearchResultsLawyerCard = (props) => {
  const { className, data = {} } = props;
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <IndentedListCard
      className={classnames(
        'search-results-card search-results-lawyer-card',
        className
      )}
      {...listCardPropsForLawyer(t, data, location)}
    />
  );
};

SearchResultsLawyerCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
};

export default SearchResultsLawyerCard;
